import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/shared/failure.svg'


const _hoisted_1 = { class: "flex flex-col min-h-screen bg-gray-100" }
const _hoisted_2 = { class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" }
const _hoisted_3 = { class: "flex flex-col w-full h-full justify-start pt-12" }
const _hoisted_4 = { class: "flex flex-col items-start w-full gap-3 px-6 sm:px-24 text-left" }
const _hoisted_5 = { class: "flex flex-col mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm leading-5 font-medium text-neutral-800"
}
const _hoisted_7 = { class: "flex justify-center mb-4" }
const _hoisted_8 = {
  key: 0,
  role: "alert",
  class: "flex gap-2 w-full justify-center p-2.5 mt-6 text-sm leading-5 text-center text-red-900 bg-red-50 rounded-lg max-md:flex-wrap",
  style: {"max-height":"80px","overflow-y":"auto"}
}
const _hoisted_9 = { class: "flex items-center mt-2 mb-2" }
const _hoisted_10 = { class: "flex items-center mt-2 mb-2" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { class: "flex flex-wrap justify-center mt-auto items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InviteTabs = _resolveComponent("InviteTabs")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_InviteByEmailSection = _resolveComponent("InviteByEmailSection")!
  const _component_LandingPagePreviewSection = _resolveComponent("LandingPagePreviewSection")!
  const _component_InviteBulkSection = _resolveComponent("InviteBulkSection")!
  const _component_InviteByLinkSection = _resolveComponent("InviteByLinkSection")!
  const _component_InviteViaSoftwareSection = _resolveComponent("InviteViaSoftwareSection")!
  const _component_FooterSection = _resolveComponent("FooterSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'bg-white rounded-lg shadow-lg w-full h-full max-w-full max-h-full relative flex flex-col',
          _ctx.selectedTab === 'manual' || _ctx.selectedTab === 'bulk'
            ? 'overflow-auto'
            : 'overflow-hidden',
        ])
      }, [
        _createElementVNode("button", {
          class: "absolute top-4 right-6 text-2xl text-gray-400 hover:text-gray-700 z-10",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, " × "),
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-3xl leading-9 font-semibold text-neutral-800 font-inter" }, "Invite Experts", -1)),
              (!_ctx.onboardingCompleted)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Almost done! Invite experts to the program"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "Error Icon",
                        class: "w-4 h-4"
                      })
                    ], -1)),
                    _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_InviteTabs, {
              selectedTab: _ctx.selectedTab,
              onTabChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTab = $event))
            }, null, 8, ["selectedTab"]),
            (_ctx.selectedTab === 'manual')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_openBlock(), _createBlock(_component_InviteByEmailSection, {
                    key: 'manual',
                    invitationType: "experts",
                    directSignup: _ctx.showLandingPage,
                    onGoBackToExperts: _ctx.handleGoBackToExperts
                  }, {
                    checkbox: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_BaseCheckbox, {
                          modelValue: _ctx.showLandingPage,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showLandingPage) = $event)),
                          id: "show-landing-page-checkbox",
                          label: "Direct users to signup form without landing page"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["directSignup", "onGoBackToExperts"])),
                  _createVNode(_component_LandingPagePreviewSection, {
                    previewImg: _ctx.invitePageImg,
                    title: "Sendoso Program Landing Page",
                    subtitle: "The experts will land on this landing page when they click to join the program",
                    about: "Welcome to the Expert Program. Our Expert Program is a structured initiative designed to identify, engage, and leverage the knowledge and expertise of our customers, partners, and advocates. Experts will have the opportunity to meet with prospective buyers or customers and share your product and industry insights and experience. We're excited to have you join our Expert Program!",
                    programUuid: _ctx.programUuid,
                    onPreview: () => {}
                  }, null, 8, ["previewImg", "programUuid"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTab === 'bulk')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.selectedTab === 'bulk')
                    ? (_openBlock(), _createBlock(_component_InviteBulkSection, {
                        key: 'bulk',
                        programId: _ctx.programId,
                        companyId: _ctx.companyId,
                        invitationType: "experts",
                        directSignup: _ctx.showLandingPageBulk,
                        onInvitesSent: _ctx.handleBulkInvitesSent
                      }, {
                        checkbox: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_BaseCheckbox, {
                              modelValue: _ctx.showLandingPageBulk,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showLandingPageBulk) = $event)),
                              id: "show-landing-page-checkbox-bulk",
                              label: "Direct users to signup form without landing page"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["programId", "companyId", "directSignup", "onInvitesSent"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_LandingPagePreviewSection, {
                    previewImg: _ctx.invitePageImg,
                    title: "Sendoso Program Landing Page",
                    subtitle: "The experts will land on this landing page when they click to join the program",
                    about: "Welcome to the Expert Program. Our Expert Program is a structured initiative designed to identify, engage, and leverage the knowledge and expertise of our customers, partners, and advocates. Experts will have the opportunity to meet with prospective buyers or customers and share your product and industry insights and experience. We're excited to have you join our Expert Program!",
                    programUuid: _ctx.programUuid,
                    onPreview: () => {}
                  }, null, 8, ["previewImg", "programUuid"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTab === 'link')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_InviteByLinkSection, {
                    invitationType: "experts",
                    directSignup: _ctx.showLandingPageLink
                  }, null, 8, ["directSignup"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_BaseCheckbox, {
                      modelValue: _ctx.showLandingPageLink,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showLandingPageLink) = $event)),
                      id: "show-landing-page-checkbox-link",
                      label: "Direct users to signup form without landing page"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_LandingPagePreviewSection, {
                    previewImg: _ctx.invitePageImg,
                    title: "Sendoso Program Landing Page",
                    subtitle: "The experts will land on this landing page when they click to join the program",
                    about: "Welcome to the Expert Program. Our Expert Program is a structured initiative designed to identify, engage, and leverage the knowledge and expertise of our customers, partners, and advocates. Experts will have the opportunity to meet with prospective buyers or customers and share your product and industry insights and experience. We're excited to have you join our Expert Program!",
                    programUuid: _ctx.programUuid,
                    onPreview: () => {}
                  }, null, 8, ["previewImg", "programUuid"])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedTab === 'software')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_InviteViaSoftwareSection, {
                    softwareList: _ctx.softwareList,
                    directSignup: _ctx.showLandingPageSoftware,
                    onSoftwareClick: _ctx.handleSoftwareClick
                  }, null, 8, ["softwareList", "directSignup", "onSoftwareClick"]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_BaseCheckbox, {
                      modelValue: _ctx.showLandingPageSoftware,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showLandingPageSoftware) = $event)),
                      id: "show-landing-page-checkbox-software",
                      label: "Direct users to signup form without landing page"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_LandingPagePreviewSection, {
                    previewImg: _ctx.invitePageImg,
                    title: "Sendoso Program Landing Page",
                    subtitle: "The experts will land on this landing page when they click to join the program",
                    about: "Welcome to the Expert Program. Our Expert Program is a structured initiative designed to identify, engage, and leverage the knowledge and expertise of our customers, partners, and advocates. Experts will have the opportunity to meet with prospective buyers or customers and share your product and industry insights and experience. We're excited to have you join our Expert Program!",
                    programUuid: _ctx.programUuid,
                    onPreview: () => {}
                  }, null, 8, ["previewImg", "programUuid"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("footer", _hoisted_13, [
            (!_ctx.onboardingCompleted)
              ? (_openBlock(), _createBlock(_component_FooterSection, {
                  key: 0,
                  isDisabled: _ctx.isDisabled,
                  setErrorMessage: _ctx.setErrorMessage,
                  currentView: "invite-experts"
                }, null, 8, ["isDisabled", "setErrorMessage"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ])
  ]))
}